<!--
 * File: Footer.vue
 * Project: timo
 * File Created: Monday, 21st September 2020 7:22:26 pm
 * Author: Timo Zacherl
 * License: MPL-2.0
 * 
 * -----
 * Last Modified: Friday, 25th September 2020 2:04:05 pm
 * Modified By: Timo Zacherl
 * -----
 * 
 * Copyright © 2020 Timo Zacherl. All rights reserved.
-->

<template>
  <footer>
    <div class="container">
      <div class="columns">
        <div class="column">
          <h4>Apps</h4>
          <ul>
            <li>
              <router-link to="/gitimoji">Gitimoji</router-link>
            </li>
          </ul>
        </div>
        <div class="column">
          <h4>Legal</h4>
          <ul class="legal-list">
            <li>
              <router-link to="/legal#privacy-policy"
                >Privacy Policy · Datenschutz</router-link
              >
            </li>
            <li>
              <router-link to="/legal">Legal Notice · Impressum</router-link>
            </li>
          </ul>
        </div>
      </div>
      <hr />
      <div class="copyright">
        <p>2020 &copy; Timo Zacherl. All rights reserved.</p>
        <p>
          Apple, the Apple logo, macOS, Mac, iPhone, and iPad are trademarks of
          Apple Inc., registered in the U.S. and other countries and regions.
          App Store is a service mark of Apple Inc. IOS is a trademark or
          registered trademark of Cisco in the U.S. and other countries and is
          used under license.
        </p>
      </div>
    </div>
  </footer>
</template>

<script>
export default {
  name: "Footer"
};
</script>

<style lang="scss" scoped>
footer {
  padding: 3.2rem 2rem 6rem 2rem;
  border-top: 1pt solid hsla(0, 0%, 93%, 1);
  background-image: linear-gradient(
    to top,
    hsla(0, 0%, 90%, 1) 75%,
    hsla(0, 0%, 96%, 1) 100%
  );
  text-align: start;

  h4 {
    margin: 0;
  }

  ul {
    list-style: none;
    margin: 0;
    padding: 0;
    min-width: 130px;

    &.legal-list {
      min-width: 230px;
    }

    li {
      margin: 0.5rem 0;
    }
  }

  a {
    text-decoration: none;
    color: inherit;
    border-bottom: none;

    &:hover {
      background: hsla(0, 0%, 100%, 1);
      border-radius: 4px;
      padding: 0.1rem 0.2rem;
      margin: -0.1rem -0.2rem;
    }
  }

  hr {
    height: 1pt;
    background: hsla(0, 0%, 86%, 1);
    border: none;
    margin-top: 1.5rem;
    margin-bottom: 1.5rem;
  }

  .copyright {
    color: hsla(0, 0%, 68%, 1);
  }

  @media screen and (max-width: 659px) {
    h4 {
      margin-top: 0.4rem;
      margin-bottom: 1.2rem;
    }

    ul {
      li {
        margin-bottom: 0.6rem;
        margin-right: 0;

        a {
          display: block;
          width: 100%;
          color: hsla(0, 0%, 30%, 1);
          background-color: hsla(0, 0%, 0%, 0.06);
          border-bottom: 2pt solid hsla(0, 0%, 0%, 0.04);
          border-radius: 4pt;
          padding: 1.2rem;
          margin: 0;
          transition: all 0.1s ease;

          &:hover {
            color: hsla(0, 0%, 26%, 1);
            background-color: hsla(0, 0%, 0%, 0.04);
            border-bottom: 2pt solid hsla(0, 0%, 0%, 0.02);
            border-radius: 4pt;
            padding: 1.2rem;
            margin: 0;
          }
        }
      }
    }
  }
}
</style>
